module.exports = __webpack_public_path__ + "static/media/16_andinvainthedreamer.5bd84698.jpg";